import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Suppress known react-helmet-async DOM errors caused by browser extensions
window.addEventListener('error', (event) => {
  if (event.message?.includes('removeChild') && event.message?.includes('not a child')) {
    event.preventDefault();
  }
});

import "@fontsource/inter";
import "@fontsource/playfair-display";
import { Suspense } from "react";
import "./i18n/config";
import { initWebVitals } from "./lib/webVitals";

// Initialize Sentry
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

if (SENTRY_DSN && !import.meta.env.DEV) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION,
  });
}

// Initialize Web Vitals reporting
initWebVitals();

const LoadingFallback = () => (
  <div className="min-h-screen bg-background flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
      <p className="text-muted-foreground">Loading...</p>
    </div>
  </div>
);

const rootElement = document.getElementById("root");

if (rootElement) {
  createRoot(rootElement).render(
    <Suspense fallback={<LoadingFallback />}>
      <App />
    </Suspense>
  );
}
